module.exports = __webpack_public_path__ + "img/sec2.77553b32.jpg";